import { Alert, Button } from "react-bootstrap";
import { DesktopComputerIcon } from "@heroicons/react/outline";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { useMemo } from "react";

import { isCourseInFuture, isRemoteEvent, shouldShowZoomLink } from "../helpers/event";

const CourseLinkButton = ({
	course
}) => {
	const shouldShowLink = useMemo(() => shouldShowZoomLink(course), [course]);
	const isRemote = useMemo(() => isRemoteEvent(course), [course]);

	return shouldShowLink
		? (
			<Button as={Link} to={`/account/classes/${course.id}/join`} variant="success">
				<DesktopComputerIcon className="i me-2" />
				Join Class
			</Button>)
		: isRemote && isCourseInFuture(course) && <Alert className="py-2" variant="warning">Video Link available 1 hour before class starts.</Alert>;
};

CourseLinkButton.propTypes = {
	course: PropTypes.shape({
		id: PropTypes.number
	}).isRequired
};

export default CourseLinkButton;
